import React from 'react';
import './PropertyDetailsTable.css';

function PropertyDetailsTable({ details }) {
  return (
    <div className="property-details-table">
      <h2 className="section-title">Property Details</h2>

      <div className="details-table">
        {Object.entries(details).map(([key, value], index) => (
          <div key={index} className="detail-row">
            <div className="detail-label">{key}</div>
            <div className="detail-value">{value}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default PropertyDetailsTable;
